import { render, staticRenderFns } from "./VerifyAccountInProgress.vue?vue&type=template&id=4d45cc5a&scoped=true"
import script from "./VerifyAccountInProgress.vue?vue&type=script&lang=js"
export * from "./VerifyAccountInProgress.vue?vue&type=script&lang=js"
import style0 from "./VerifyAccountInProgress.vue?vue&type=style&index=0&id=4d45cc5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45cc5a",
  null
  
)

export default component.exports